import * as THREE from 'three'

export type RingStyle = 'band' | 'solitaire' | 'signet'

export interface ProceduralRingOptions {
  style: RingStyle
  metal: number | string
  accent: number | string
  /** Inner diameter (cm). */
  innerDiameter: number
}

export const RING_DEFAULTS: ProceduralRingOptions = {
  style: 'band',
  metal: 0xd4a94a,
  accent: 0xeef3ff,
  innerDiameter: 1.75,
}

function metal(c: number | string): THREE.MeshStandardMaterial {
  return new THREE.MeshStandardMaterial({ color: new THREE.Color(c), metalness: 1, roughness: 0.22, envMapIntensity: 1.2 })
}
function gem(c: number | string): THREE.MeshPhysicalMaterial {
  return new THREE.MeshPhysicalMaterial({ color: new THREE.Color(c), metalness: 0, roughness: 0.05, clearcoat: 1, envMapIntensity: 1.4, transparent: true, opacity: 0.9 })
}

/** Rings authored in cm: band axis = +Z (finger direction), stone on +Y (back of the hand). */
export function createProceduralRing(options: Partial<ProceduralRingOptions> = {}): THREE.Group {
  const o = { ...RING_DEFAULTS, ...options }
  const g = new THREE.Group()
  g.name = `procedural-ring-${o.style}`
  const r = o.innerDiameter / 2
  const bandThickness = o.style === 'signet' ? 0.11 : 0.08
  const band = new THREE.Mesh(new THREE.TorusGeometry(r + bandThickness / 2, bandThickness, 12, 42), metal(o.metal))
  band.name = 'band'
  g.add(band) // torus plane is XY, hole along +Z = finger axis — already correct
  if (o.style === 'solitaire') {
    const seatY = r + bandThickness
    const stone = new THREE.Mesh(new THREE.OctahedronGeometry(0.24, 1), gem(o.accent))
    stone.name = 'stone'
    stone.position.y = seatY + 0.16
    stone.rotation.z = Math.PI / 4
    const prongs = new THREE.Mesh(new THREE.CylinderGeometry(0.16, 0.1, 0.22, 8), metal(o.metal))
    prongs.name = 'setting'
    prongs.position.y = seatY + 0.02
    g.add(stone, prongs)
  } else if (o.style === 'signet') {
    const face = new THREE.Mesh(new THREE.CylinderGeometry(0.42, 0.5, 0.22, 20), metal(o.metal))
    face.name = 'face'
    face.position.y = r + bandThickness + 0.05
    g.add(face)
  }
  return g
}
